import { useEffect } from "react";

export default function DownloadClubRedirectPage() {
    const handleGoToStoreClick = () => {
        const params = new URLSearchParams(window.location.search);
        const clubId = params.get("clubId");

        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

        const iosUrl = `https://apps.apple.com/de/app/baila/id6462697936${clubId ? `?clubId=${clubId}` : ""}`;
        const androidUrl = `https://play.google.com/store/apps/details?id=com.baila_client${clubId ? `&clubId=${clubId}` : ""}`;

        if (/android/i.test(userAgent)) {
            window.location.href = androidUrl;
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
            window.location.href = iosUrl;
        } else {
            window.location.href = iosUrl;
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const clubId = params.get("clubId");

        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

        const iosUrl = `https://apps.apple.com/de/app/baila/id6462697936${clubId ? `?clubId=${clubId}` : ""}`;
        const androidUrl = `https://play.google.com/store/apps/details?id=com.baila_client${clubId ? `&clubId=${clubId}` : ""}`;
        const deepLinkUrl = `baila://app/club${clubId ? `?clubId=${clubId}` : ""}`;

        const goToStore = () => {
            if (/android/i.test(userAgent)) {
                window.location.href = androidUrl;
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
                window.location.href = iosUrl;
            } else {
                window.location.href = iosUrl;
            }
        };

        let didHide = false;
        let fallbackTimer: number | undefined;

        const clearFallback = () => {
            if (fallbackTimer !== undefined) {
                window.clearTimeout(fallbackTimer);
                fallbackTimer = undefined;
            }
        };

        const onHide = () => {
            didHide = true;
            clearFallback();
        };

        document.addEventListener("visibilitychange", onHide);
        window.addEventListener("pagehide", onHide);
        window.addEventListener("blur", onHide);

        window.location.href = deepLinkUrl;

        fallbackTimer = window.setTimeout(() => {
            if (!didHide && document.visibilityState === "visible") {
                goToStore();
            }
        }, 6000);

        return () => {
            clearFallback();
            document.removeEventListener("visibilitychange", onHide);
            window.removeEventListener("pagehide", onHide);
            window.removeEventListener("blur", onHide);
        };
    }, []);

    return (
        <div className="flex items-center justify-center h-screen">
            <div className="flex flex-col items-center gap-3">
                <p className="text-lg">Redirecting you to the right app store…</p>
                <button
                    type="button"
                    onClick={handleGoToStoreClick}
                    className="rounded-full bg-white px-6 py-3 text-black hover:bg-neutral-100"
                >
                    Zum Appstore
                </button>
            </div>
        </div>
    );
}
